import { render } from "./CardTitle.vue?vue&type=template&id=206843a3"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/CardTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "206843a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('206843a3', __exports__)) {
    api.reload('206843a3', __exports__)
  }
  
  module.hot.accept("./CardTitle.vue?vue&type=template&id=206843a3", () => {
    api.rerender('206843a3', render)
  })

}


export default __exports__